export default function RSVP() {
    return (
        <section id="rsvp" className="py-24 bg-stone-50 px-4 flex items-center justify-center">
            <div className="w-full max-w-3xl bg-white rounded-3xl shadow-xl p-12 text-center border-t-8 border-wedding-green">
                <h2 className="text-4xl font-serif text-wedding-navy mb-4">RSVPs Are Closed</h2>
                <p className="text-gray-600 font-serif text-lg">
                    Thank you to everyone who responded. We're no longer accepting new RSVPs.
                </p>
            </div>
        </section>
    );
}
